import { useState, useEffect } from "react";
import { FaPhone, FaEnvelope, FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../Pages/images/logo.png";
import "./Navbar.css";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    "HOME",
    "SERVICES",
    "COUNTRIES",
    "COACHING",
    "SUCCESS STORIES",
    "UNIVERSITIES",
    "ABOUT US",
    "CONTACT US",
    "FREE COUNSELLING",
  ];

  return (
    <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        
        <div className="logo">
          <img src={logo} alt="Logo" />
        </div>

        {/* Right - Contact info and nav links */}
        <div className="right-section">
          <div className="top-contact">
  <div className="contact-item">
    <FaPhone />
    <span>+91 9618001019</span>
  </div>
  <div className="contact-item">
    <FaEnvelope />
    <span>Clyraoverseas@gmail.com</span>
  </div>
  <div className="contact-item">
    <span>Office Timings: 10 AM - 5 PM</span>
  </div>
</div>

{/* Place hamburger button outside to always show */}
<button className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
  {isMenuOpen ? <FaTimes /> : <FaBars />}
</button>


          <div className="nav-links-container">
            <ul className="nav-links">
              {navItems.map((item, index) => (
                <li key={index}>
                  <Link to={`/${item.toLowerCase().replace(/\s/g, "")}`}>{item}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="mobile-menu">
          <ul>
            {navItems.map((item, index) => (
              <li key={index}>
                <Link
                  to={`/${item.toLowerCase().replace(/\s/g, "")}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item}
                </Link>
              </li>
            ))}
          </ul>
          <div className="mobile-contact">
            <div className="contact-item">
              <FaPhone />
              <span>+91 9618001019</span>
            </div>
            <div className="contact-item">
              <FaEnvelope />
              <span>Clyraoverseas@gmail.com</span>
            </div>
            <div className="contact-item">
              <span>Office Timings: 10 AM - 4 PM</span>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
